/*******************************************************************************
 * storage.js - LocalStorage Helpers
 ******************************************************************************/

import { logToServer } from './api.js';

/**
 * Get data from localStorage
 * @param {string} key - Storage key
 * @returns {Array} - Parsed data or empty array
 */
export function getFromStorage(key) {
    try {
        var data = localStorage.getItem(key);
        return data ? JSON.parse(data) : [];
    } catch (e) {
        logToServer("error", "Error reading from localStorage", { key: key, error: e.message });
        return [];
    }
}

/**
 * Save data to localStorage
 * @param {string} key - Storage key
 * @param {*} data - Data to save
 */
export function saveToStorage(key, data) {
    try {
        localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
        logToServer("error", "Error saving to localStorage", { key: key, error: e.message });
    }
}

/**
 * Remove data from localStorage
 * @param {string} key - Storage key
 */
export function removeFromStorage(key) {
    try {
        localStorage.removeItem(key);
    } catch (e) {
        logToServer("error", "Error removing from localStorage", { key: key, error: e.message });
    }
}

/**
 * Get selection from storage filtered by orgId
 * @param {string} orgId - Organization ID
 * @returns {Array} - Filtered selection
 */
export function getSelectionByOrgId(orgId) {
    try {
        const storedData = localStorage.getItem('selectedData');
        const parsedData = storedData ? JSON.parse(storedData) : [];
        return parsedData.filter(item => item.orgId === orgId);
    } catch (error) {
        console.error('Error retrieving selection:', error);
        return [];
    }
}

/**
 * Save selection and store for remittance
 * @param {Array} selectedData - Selected data to save
 */
export function saveSelection(selectedData) {
    try {
        localStorage.setItem('selectedData', JSON.stringify(selectedData));
    } catch (error) {
        console.error('Error saving selection:', error);
    }
}

/**
 * Clear selection for a specific organization
 * @param {string} subscriptionID - Subscription/org ID to clear
 */
export function clearSelectionByOrgId(subscriptionID) {
    try {
        const existingSelection = JSON.parse(localStorage.getItem('selectedData')) || [];
        const filteredSelection = existingSelection.filter(function (item) {
            return item.orgId !== undefined && item.orgId !== subscriptionID;
        });
        localStorage.setItem('selectedData', JSON.stringify(filteredSelection));
    } catch (error) {
        console.error('Error clearing selection:', error);
    }
}
